import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Switch,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  Link,
} from '@mui/material';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions, ManagementActions } from '../../../Services/_actions';
import { useNavigate, useParams } from 'react-router';
import { PaginatedResponse, UserObject } from '../../../interfaces/Management.interface.ts';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { stateListAtom } from '../../../Services/_states/Constant.js';
import {
  createUserFormDataAtom,
  createUserFormDataErrorsAtom,
  organisationFormDataAtom,
  organisationFormDataErrorAtom,
  organisationTableStateAtom,
} from '../../../Services/_states/index.js';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import { validateOrganisationForm, validateUserForm } from '../validations.ts';
import OrganizationForm from './Onboarding/OrganisationForm.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
const CreateEditForm: React.FC = () => {
  const constantActions = ConstantActions();
  const actions = ManagementActions();
  const [formData, setFormData] = useRecoilState(organisationFormDataAtom);
  const setOrganisationFormDataErrors = useSetRecoilState(organisationFormDataErrorAtom);
  const { showSnackBar } = useSnackBar();
  const { mode } = useParams();
  const navigate = useNavigate();
  const [tableState, setTableState] = useRecoilState(organisationTableStateAtom);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false); // state for confirmation dialog
  const [apiResponse, setApiResponse] = useState(null);
  const [file, setFile] = useState<File | null>(null);

  const handleSubmit = async () => {
    let result = validateOrganisationForm(formData);
    setOrganisationFormDataErrors(result);

    if (Object.keys(result).length === 0) {
      let logoUrl = formData.logo_url || '';
      if (file && file instanceof File) {
        const formDataToUpload = new FormData();
        formDataToUpload.append('file', file);
        try {
          const resp = await constantActions.uploadFileS3Bucket(formDataToUpload);
          if (resp?.status === 200 && resp?.data?.data?.url) {
            logoUrl = resp.data.data.url;
            showSnackBar('Logo uploaded successfully!', 'success');
          } else {
            showSnackBar('Logo upload failed. Proceeding with existing logo.', 'warning');
          }
        } catch (error: any) {
          showSnackBar(`Error uploading logo: ${error.message}`, 'error');
        }
      }

      const payload = { ...formData, logo_url: logoUrl || formData.logo_url || '' };

      if (mode === 'create') {
        let res = await actions.createOrganisation(payload);
        if (res?.status === 200) {
          setApiResponse(res?.data?.data);
          setTableState((prev) => ({
            ...prev,
            cache: {},
            totalCountCache: {},
            isLoading: true,
          }));
          showSnackBar('Organisation Created Successfully', 'success');
          setIsConfirmDialogOpen(true);
        } else {
          showSnackBar('Error in Creating Organisation', 'error');
        }
      } else if (mode === 'edit') {
        let res = await actions.updateOrganisation(payload);
        if (res?.status === 200) {
          showSnackBar('Organisation Updated Successfully', 'success');
          setTableState((prev) => ({
            ...prev,
            cache: {},
            totalCountCache: {},
            isLoading: true,
          }));
          navigate(-1);
        } else {
          showSnackBar('Error in Updating Organisation', 'error');
        }
      }
    } else {
      showSnackBar('Error in creating organisation', 'error');
      return 0;
    }
  };

  const handleConfirmation = async (isConfirmed: boolean) => {
    setIsConfirmDialogOpen(false);
    console.log('apiResponse1111', apiResponse);
    if (isConfirmed && apiResponse) {
      navigate(
        `/r/management/createAccount?orgId=${apiResponse?.organisation_id}&orgName=${apiResponse?.name}`
      );
    } else {
      navigate(-1);
    }
  };
  useEffect(() => {
    if (mode === 'edit' && !formData?.organisation_id) {
      navigate('/r/management/organisation-list/');
    }
  }, []);

  return (
    <Box
      sx={{
        padding: '20px',
        maxWidth: '900px',
        margin: 'auto',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <OrganizationForm onLogoSelect={setFile} />
      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
        <Button variant="outlined" size="small" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={(e: any) => handleSubmit()}
          color="primary"
          size="small"
        >
          {mode === 'edit' ? 'Update' : 'Create'}
        </Button>
      </Box>
      <ConfirmBox
        open={isConfirmDialogOpen}
        onClose={handleConfirmation}
        options={{
          title: 'Account Create',
          text: 'Do you want to create a Account?',
          confirmButtonText: 'yes',
          cancelButtonText: 'Cancel',
          confirmButtonColor: 'primary',
          cancelButtonColor: 'default',
        }}
      />
    </Box>
  );
};

export default CreateEditForm;
